import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _77c4b4bd = () => interopDefault(import('..\\pages\\document-error.vue' /* webpackChunkName: "pages_document-error" */))
const _42159bb6 = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _7754f571 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _886e59ac = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _2202660d = () => interopDefault(import('..\\pages\\patient-information.vue' /* webpackChunkName: "pages_patient-information" */))
const _9640131c = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _1e1bd8be = () => interopDefault(import('..\\pages\\signature.vue' /* webpackChunkName: "pages_signature" */))
const _18175f52 = () => interopDefault(import('..\\pages\\ssuccess.vue' /* webpackChunkName: "pages_ssuccess" */))
const _2e7dfdac = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _0253a7ec = () => interopDefault(import('..\\pages\\timeout.vue' /* webpackChunkName: "pages_timeout" */))
const _a1c72fe2 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _31169352 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _3124aad3 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _3140d9d5 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _314ef156 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _65fcce93 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _338ed73b = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/document-error",
    component: _77c4b4bd,
    name: "document-error"
  }, {
    path: "/eligibility",
    component: _42159bb6,
    name: "eligibility"
  }, {
    path: "/error",
    component: _7754f571,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _886e59ac,
    name: "have-a-card"
  }, {
    path: "/patient-information",
    component: _2202660d,
    name: "patient-information"
  }, {
    path: "/rejection",
    component: _9640131c,
    name: "rejection"
  }, {
    path: "/signature",
    component: _1e1bd8be,
    name: "signature"
  }, {
    path: "/ssuccess",
    component: _18175f52,
    name: "ssuccess"
  }, {
    path: "/success",
    component: _2e7dfdac,
    name: "success"
  }, {
    path: "/timeout",
    component: _0253a7ec,
    name: "timeout"
  }, {
    path: "/upload-documents",
    component: _a1c72fe2,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _31169352,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _3124aad3,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _3140d9d5,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _314ef156,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _65fcce93,
    name: "errors-500"
  }, {
    path: "/",
    component: _338ed73b,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
